<template>
<div class="chapter">
<div class="inner_page">
<h2 class="P_Heading_2" id="auto_bookmark_toc_4"><span>Author’s Note</span></h2>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent"><span style=" font-size: 0.93em;">THERE ARE</span> not enough vowels in the English language to describe how delighted I am with the illustrations for <i>Elf Shot</i>. If I tried only dolphins and French Bulldogs would have any clue what was going on. Using only my rambling and a few bizarre stick figure drawings to explain how I wanted to set the scene Emily captured the perfect essence of the story and characters just as I imagined them. I am always impressed by anyone who can draw (the bizarre stick figure drawings are the height of my artistic talents), and had previously been a fan of Em's adorable cartoon series<i>, Stupid Fox. </i>However, being part of the process from start to finish was an amazing experience.</p>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent"> </p>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent">I adore Em's vision of the <i>Elf Shot </i>world and I hope you do as well. She is amazingly talented.</p>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent"> </p>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent__OPENPAR_1_CLOSEPAR_">Tamm</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0004.vue?1647f5aa